module.exports = __webpack_public_path__ + "img/duffle.772ca140.jpg";